class ExperianAddressValidation {
	setSearchTerms() {
		this.searchTerms = '';

		this.addressSearchInputs.forEach((input, index) => {
			if (input.value.length > 0) {
				if (index === 0) {
					this.searchTerms = input.value;
				} else {
					this.searchTerms = `${this.searchTerms} , ${input.value}`;
				}
			}
		});
	}

	searchAddress() {
		fetch(`/ajax/address/suggestions?searchTerm=${this.searchTerms}`, {
			method: 'POST',
		})
			.then(response => response.json())
			.then(data => {
				this.clearSearchDropdown();

				if (data.data.suggestions) {
					data.data.suggestions.forEach(suggestion => {
						const suggestionText = this.highlightText(suggestion);
						const suggestionFormatUrl = suggestion.key;
						this.insertAddressInDropdown(
							suggestionText,
							suggestionFormatUrl,
							false,
						);
					});
				} else {
					this.insertAddressInDropdown(this.noSearchResultsMessage, '', true);
				}

				this.addButtonInDropdown();
				this.addressSearchDropdown.classList.add('is-visible');
				this.searchTerms = '';
			})
			.catch(error => {
				console.log(error); // eslint-disable-line no-console
			});
	}

	formatChoosenAddress() {
		fetch(`/ajax/address/format?globalAddressKey=${this.choosenAddress}`)
			.then(response => response.json())
			.then(data => {
				if (data.status === 'ERROR') {
					this.alertBoxMessageFirst.classList.add('hidden');
					this.alertBoxMessageSecond.classList.remove('hidden');
					this.addressFormRows.forEach(row => row.classList.remove('hidden'));
				} else {
					const choosenAddressData = data.data;
					const addressLine1Value = choosenAddressData.addressLine1
						? choosenAddressData.addressLine1
						: '';
					const addressLine2Value = choosenAddressData.addressLine2
						? choosenAddressData.addressLine2
						: '';
					const postalCodeValue = choosenAddressData.postalCode
						? choosenAddressData.postalCode
						: '';
					const cityValue = choosenAddressData.town
						? choosenAddressData.town
						: '';

					this.setAddressInputsValues(
						addressLine1Value,
						addressLine2Value,
						postalCodeValue,
						cityValue,
					);

					this.setAddressCardValues(
						this.defaultAddressCard,
						addressLine1Value,
						addressLine2Value,
						postalCodeValue,
						cityValue,
					);

					this.choosenAddress = '';

					this.setValidAddressInStorageDuringSearch();

					this.initAddressFormInputsValidation();

					this.checkRequiredAddressFormInputs();

					setTimeout(() => {
						if (this.countOfErrors > 0) {
							this.addressFormRows.forEach(row =>
								row.classList.remove('hidden'),
							);
						} else {
							this.defaultAddressCard.classList.remove('hidden');
						}
					}, 1000);
				}
			})
			.catch(error => {
				console.log(error); // eslint-disable-line no-console
			});
	}

	initAddressFormInputsValidation() {
		const addressFields = [
			this.addressLine1,
			this.addressPostalCode,
			this.addressCity,
		];

		// Only include addressLine2 if it exists
		if (this.addressLine2) {
			addressFields.push(this.addressLine2);
		}

		addressFields.forEach(field => {
			if (field) field.dispatchEvent(new Event('blur', { bubbles: true }));
		});

		this.countOfErrors = 0;

		this.addressFormRows.forEach(row => {
			if (row.querySelector('.form-text-errors')?.innerHTML.length > 0) {
				this.countOfErrors += 1;
			}
		});
	}

	checkRequiredAddressFormInputs() {
		const requiredAddressFields = [
			this.addressLine1,
			this.addressPostalCode,
			this.addressCity,
		];

		requiredAddressFields.forEach(field => {
			if (!field.value.length) {
				this.countOfErrors += 1;
				field.value = ' ';
				field.dispatchEvent(new Event('blur', { bubbles: true }));
			}
		});
	}

	setAddressInputsValues(
		addressLine1Value = '',
		addressLine2Value = '',
		addressPostalCodeValue = '',
		addressCityValue = '',
	) {
		this.addressLine1.value = addressLine1Value;
		this.addressLine1.dispatchEvent(new Event('change', { bubbles: true }));

		// Only include addressLine2 if it exists
		if (this.addressLine2) {
			this.addressLine2.value = addressLine2Value;
			this.addressLine2.dispatchEvent(new Event('change', { bubbles: true }));
		}

		this.addressPostalCode.value = addressPostalCodeValue;
		this.addressPostalCode.dispatchEvent(
			new Event('change', { bubbles: true }),
		);

		this.addressCity.value = addressCityValue;
		this.addressCity.dispatchEvent(new Event('change', { bubbles: true }));
	}

	insertAddressInDropdown(text, formatUrl = '', isEmptyState) {
		const newSuggestionItem = this.addressSearchDropdownItem.cloneNode(true);

		newSuggestionItem.innerHTML = text;
		newSuggestionItem.setAttribute('data-format-url', formatUrl);
		this.addressSearchDropdown.append(newSuggestionItem);
		newSuggestionItem.classList.remove('hidden');
		if (isEmptyState) {
			newSuggestionItem.classList.add('is-empty-state');
		}
	}

	addButtonInDropdown() {
		const enterAddressManuallyBtnElem = document.createElement('li');
		enterAddressManuallyBtnElem.className =
			'address-search__dropdown-item js-address-search-no-results-link';
		enterAddressManuallyBtnElem.innerHTML = `<button type="button" class="address-search__btn-link">
				${this.enterAddressManuallyBtnText}
			</button>`;

		this.addressSearchDropdown.appendChild(enterAddressManuallyBtnElem);
	}

	highlightText(suggestion) {
		let textOfSuggestion = suggestion.address;
		for (let i = 0; i < suggestion.matched.length; i++) {
			const highlight = textOfSuggestion
				.replaceAll('<b>', '')
				.replaceAll('</b>', '')
				.slice(suggestion.matched[i][0], suggestion.matched[i][1]);
			const textArray = textOfSuggestion.split(highlight);
			textOfSuggestion = textArray.join(`<b>${highlight}</b>`);
		}
		return textOfSuggestion;
	}

	setChoosenAddress(choosenItem) {
		this.choosenAddress = choosenItem.getAttribute('data-format-url');
	}

	hideSearchAddressBlock() {
		this.addressSearchBlock.classList.add('hidden');
		this.hideSearchDropdown();
		this.clearSearchInputs();
		this.removeErrorMsgsForEmptyLookupInputs();
	}

	clearSearchDropdown() {
		this.addressSearchDropdown
			.querySelectorAll('.js-address-search-dropdown-item:not(.hidden)')
			.forEach(item => {
				item.remove();
			});

		const addManuallyBtn = this.addressSearchDropdown.querySelector(
			'.js-address-search-no-results-link',
		);

		if (addManuallyBtn) {
			addManuallyBtn.remove();
		}
	}

	hideSearchDropdown() {
		this.addressSearchDropdown.classList.remove('is-visible');
		this.clearSearchDropdown();
	}

	clearSearchInputs() {
		this.addressSearchInputs.forEach(input => {
			input.value = '';
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	setValidAddressInStorageDuringSearch() {
		localStorage.setItem(
			'validAddressLine1',
			`${this.stringToHash(this.addressLine1.value)}`,
		);
		localStorage.setItem(
			'validAddressPostalCode',
			`${this.stringToHash(this.addressPostalCode.value)}`,
		);
		localStorage.setItem(
			'validAddressCity',
			`${this.stringToHash(this.addressCity.value)}`,
		);
	}

	setValidDeliveryAddressInStorageDuringEditing(e) {
		const addressId = e.target
			.closest('.js-address-search-section')
			.querySelector('input[name="addressId"]').value;

		fetch(`/ajax/myaccount/shipping-address/data`)
			.then(response => response.json())
			.then(data => {
				const shippingAddressList = data?.shippingAddress || [];
				const editedAddressObject = shippingAddressList.find(
					address => address.addressId === addressId,
				);

				if (editedAddressObject) {
					this.setValidAddressInStorageDuringEditing(editedAddressObject);
				}
			});
	}

	setValidBillingAddressInStorageDuringEditing() {
		fetch(`/ajax/checkout/billing-address/data`)
			.then(response => response.json())
			.then(data => {
				const editedAddressObject = data.billingAddress;
				this.setValidAddressInStorageDuringEditing(editedAddressObject);
			});
	}

	setValidAddressInStorageDuringEditing(editedAddressObject) {
		if (editedAddressObject?.validAddress) {
			localStorage.setItem(
				'validAddressLine1',
				`${this.stringToHash(editedAddressObject.line1)}`,
			);
			localStorage.setItem(
				'validAddressPostalCode',
				`${this.stringToHash(editedAddressObject.postalCode)}`,
			);
			localStorage.setItem(
				'validAddressCity',
				`${this.stringToHash(editedAddressObject.town)}`,
			);
		}
	}

	stringToHash(string) {
		let hash = 0;

		if (!string || string.length === 0) return hash;

		for (let i = 0; i < string.length; i++) {
			const char = string.charCodeAt(i);
			/* eslint no-bitwise: ["error", { "allow": ["<<", "&="] }] */
			hash = (hash << 5) - hash + char;
			hash &= hash;
		}
		return hash;
	}

	setAddressVerifiedFlagValue(e) {
		const validAddressInput = e.target
			.closest('.js-address-search-section')
			.querySelector('input[name="validAddress"]');
		const validCompanyInput = document.getElementById('validCompanyId');

		if (!validAddressInput) {
			return;
		}

		if (
			`${this.stringToHash(this.addressLine1?.value)}` ===
				localStorage.getItem('validAddressLine1') &&
			`${this.stringToHash(this.addressPostalCode?.value)}` ===
				localStorage.getItem('validAddressPostalCode') &&
			`${this.stringToHash(this.addressCity?.value)}` ===
				localStorage.getItem('validAddressCity')
		) {
			validAddressInput.value = 'true';
		} else if (validCompanyInput?.value === 'true') {
			validAddressInput.value = 'true';
		} else {
			validAddressInput.value = 'false';
		}

		validAddressInput.dispatchEvent(new Event('change', { bubbles: true }));
	}

	removeValidAddressInStorage() {
		localStorage.removeItem('validAddressLine1');
		localStorage.removeItem('validAddressPostalCode');
		localStorage.removeItem('validAddressCity');
	}

	setAddressCardValues(
		cardElem,
		addressLine1Value,
		addressLine2Value,
		postalCodeValue,
		cityValue,
	) {
		const currentCountry = document.querySelector('.js-current-country');
		const line1 = cardElem.querySelector('.js-address-card-line1');
		const line2 = cardElem.querySelector('.js-address-card-line2');
		const line3 = cardElem.querySelector('.js-address-card-line3');
		const line4 = cardElem.querySelector('.js-address-card-line4');

		if (currentCountry.value === 'en' || currentCountry.value === 'en_IE') {
			line1.textContent = addressLine2Value;
			line2.textContent = addressLine1Value;
			line3.textContent = cityValue;
			line4.textContent = postalCodeValue;
		} else {
			line1.textContent = addressLine1Value;

			if (line2) {
				line2.textContent = addressLine2Value;
			}

			line3.textContent = `${postalCodeValue} ${cityValue}`;
		}
	}

	setDomElements(e) {
		this.searchSection = e.target.closest('.js-address-search-section');
		this.addressSearchBlock = this.searchSection.querySelector(
			'.js-address-search-block',
		);
		this.addressSearchInputs = this.searchSection.querySelectorAll(
			'.js-address-search-input',
		);
		this.addressSearchInitAutocompleteInput = this.searchSection.querySelector(
			'.js-address-search-init',
		);
		this.disabledLookupInputs =
			this.searchSection.querySelectorAll('.js-validate-input');
		this.addressSearchDropdown = this.searchSection.querySelector(
			'.js-address-search-dropdown',
		);
		this.addressSearchDropdownItem = this.searchSection.querySelector(
			'.js-address-search-dropdown-item',
		);
		this.addressResultsWrapper = this.searchSection.querySelector(
			'.js-address-results-wrapper',
		);
		this.addressLine1 = this.searchSection.querySelector('.js-address-line-1');
		this.addressLine2 = this.searchSection.querySelector('.js-address-line-2');
		this.addressPostalCode = this.searchSection.querySelector(
			'.js-address-postal-code',
		);
		this.addressCity = this.searchSection.querySelector('.js-address-city');
		this.noSearchResultsMessage = document.querySelector(
			'.js-no-search-results-message',
		).value;
		this.enterAddressManuallyBtnText = document.querySelector(
			'.js-enter-manually-message',
		).value;
		this.addressFormRows = this.searchSection.querySelectorAll(
			'.js-address-form-row',
		);
		this.defaultAddressCard = this.searchSection.querySelector(
			'.js-default-address-static-card',
		);
		this.currentAddressCard = this.searchSection.querySelector(
			'.js-current-address-static-card',
		);
		this.postalCodeLookupInput = this.searchSection.querySelector(
			'.js-address-search-input.js-validate-postal-code-input',
		);
		this.postalCodeFormBlock = this.searchSection.querySelector(
			'.js-postal-code-validation-block.js-address-form-row',
		);
		this.errorMsg = this.searchSection.querySelector(
			'.js-validation-error-msg',
		);
		this.emptyPostalCodeErrorMsg = this.searchSection.querySelector(
			'.js-empty-validation-error-msg',
		);
		this.alertBoxMessageFirst = this.searchSection.querySelector(
			'.js-alert-box-text-first',
		);
		this.alertBoxMessageSecond = this.searchSection.querySelector(
			'.js-alert-box-text-second',
		);
	}

	setFormPostalCodeValue() {
		if (this.postalCodeLookupInput && this.postalCodeLookupInput.value) {
			this.addressPostalCode.value = this.postalCodeLookupInput.value;
			this.addressPostalCode.dispatchEvent(
				new Event('change', { bubbles: true }),
			);
		}
	}

	setFormPostalCodeErrorStatus() {
		if (this.postalCodeLookupInput) {
			this.addressPostalCode.classList.remove(
				'valid',
				'is-valid',
				'invalid',
				'is-invalid',
			);

			if (this.postalCodeFormBlock.classList.contains('has-error')) {
				this.postalCodeFormBlock.classList.remove('has-error');
			}

			if (this.postalCodeFormBlock.querySelector('.form-text-errors')) {
				this.postalCodeFormBlock.querySelector('.form-text-errors').innerHTML =
					'';
			}

			if (this.postalCodeFormBlock.querySelector('.error')) {
				this.postalCodeFormBlock.querySelector('.error').remove();
			}

			if (this.postalCodeLookupInput.classList.contains('invalid')) {
				this.addressPostalCode.classList.add('is-invalid', 'invalid');
				this.addressPostalCode.dispatchEvent(new Event('focus'));
				this.addressPostalCode.dispatchEvent(
					new Event('blur', { bubbles: true }),
				);

				if (!document.querySelector('.legacy-namespacing')) {
					this.postalCodeFormBlock.classList.add('has-error');
				}
			} else if (this.postalCodeLookupInput.classList.contains('valid')) {
				this.addressPostalCode.classList.add('is-valid', 'valid');
			}

			this.disableLookupInputs();
		}
	}

	disableLookupInputs() {
		if (this.disabledLookupInputs.length > 0) {
			this.disabledLookupInputs.forEach(input => {
				input.disabled = true;
			});
		}
	}

	initSearch(e) {
		this.setDomElements(e);

		if (this.addressSearchInitAutocompleteInput) {
			this.addressSearchInitAutocompleteInput.classList.add('is-inited');
			this.addressSearchInitAutocompleteInput.addEventListener('input', () => {
				this.setSearchTerms();
				if (this.searchTerms) {
					this.searchAddress();
				}
			});
		}
	}

	setValidFlagForEditingDeliveryAddressInCheckout() {
		if (document.querySelector('input[name="validAddress"]').value) {
			localStorage.setItem(
				'validAddressLine1',
				`${this.stringToHash(
					document.querySelector('.js-address-line-1').value,
				)}`,
			);
			localStorage.setItem(
				'validAddressPostalCode',
				`${this.stringToHash(
					document.querySelector('.js-address-postal-code').value,
				)}`,
			);
			localStorage.setItem(
				'validAddressCity',
				`${this.stringToHash(
					document.querySelector('.js-address-city').value,
				)}`,
			);
		}
	}

	resetSearchInputsValidation() {
		this.addressSearchInputs.forEach((input, index) => {
			input.classList.remove('valid', 'invalid');
			if (index > 0) {
				input.setAttribute('disabled', true);
			}
		});
	}

	toggleDefaultDeliveryAddress(e, showAddress, isErrorSkipped, isTimeout) {
		const searchSection = e.target.closest('.js-address-search-section');

		const defaultAddress = searchSection?.querySelector('.js-default-address');

		const toggleDefaultAddressBlock = () => {
			const errorMsg = searchSection?.querySelector('.error');

			if (showAddress && (!errorMsg || (errorMsg && isErrorSkipped))) {
				defaultAddress.classList.remove('hidden');
			} else {
				defaultAddress.classList.add('hidden');
			}
		};

		if (defaultAddress) {
			if (isTimeout) {
				setTimeout(() => {
					toggleDefaultAddressBlock();
				}, 50);
			} else {
				toggleDefaultAddressBlock();
			}
		}
	}

	toggleAddNewAddressBlockElemsDisplaying() {
		setTimeout(() => {
			const newAddressBlock = document.querySelector(
				'.js-add-new-address-block',
			);
			newAddressBlock
				.querySelector('.js-edit-address-elems')
				.classList.add('hidden');
			newAddressBlock
				.querySelector('.js-address-search-block-title')
				.classList.remove('hidden');
		}, 100);
	}

	validateEmptyLookupInputsOnSubmit() {
		if (
			!this.addressLine1.value ||
			!this.addressPostalCode.value ||
			!this.addressCity.value
		) {
			this.addressSearchInputs.forEach(input => {
				if (!input.value) {
					input
						.closest('div')
						.querySelector('.js-empty-lookup-input-error-msg')
						.classList.remove('hidden');

					if (!input.disabled) {
						input.classList.add('invalid');
					}
				}
			});
		}
	}

	removeErrorMsgsForEmptyLookupInputs(e) {
		if (!this.addressSearchInputs) {
			this.setDomElements(e);
		}
		this.addressSearchInputs.forEach(input => {
			input
				.closest('div')
				.querySelector('.js-empty-lookup-input-error-msg')
				.classList.add('hidden');

			input.classList.remove('valid', 'invalid');
		});

		if (this.errorMsg) {
			this.errorMsg.classList.add('hidden');
		}
	}

	simulateSubmitButtonClick(form, clickEvent) {
		const submitButton = form.querySelector('.js-save-address-btn');
		submitButton.dispatchEvent(clickEvent);
	}

	listenForSimulatedClick(form, clickEvent) {
		form.addEventListener(clickEvent, function (e) {
			this.submitForm(e);
		});
	}

	handleSubmitOnEnter(form) {
		const clickEvent = new Event('click');

		this.listenForSimulatedClick(form, clickEvent);
		this.simulateSubmitButtonClick(form, clickEvent);
	}

	submitForm(e) {
		const submitBtn = e.target;
		submitBtn.focus();
		submitBtn.dispatchEvent(new Event('submit'));
	}

	onSubmitFormEvents(e, isEnterPressed) {
		const form = e.target.closest('form');
		let requiredEmptyInputsCount = 0;

		this.validateEmptyLookupInputsOnSubmit();

		form
			.querySelectorAll('.form-inline-row--is-mandatory input')
			.forEach(input => {
				if (!input.value) {
					requiredEmptyInputsCount += 1;
				}
			});

		this.setAddressVerifiedFlagValue(e);

		if (requiredEmptyInputsCount === 0) {
			if (isEnterPressed === 'true') {
				this.handleSubmitOnEnter(form);
			} else {
				this.submitForm(e);
			}
		}
	}

	actionsForEventOnNoResultsLink(e) {
		e.preventDefault();
		this.setDomElements(e);
		this.setFormPostalCodeValue();
		this.setFormPostalCodeErrorStatus();
		this.hideSearchAddressBlock();
		this.defaultAddressCard.classList.add('hidden');
		this.addressFormRows.forEach(row => row.classList.remove('hidden'));
	}

	actionsForEventOnReturnAddressLookupBtn(e) {
		this.setDomElements(e);
		this.addressSearchBlock.classList.remove('hidden');
		this.addressFormRows.forEach(row => row.classList.add('hidden'));
		this.disableLookupInputs();
	}

	actionsForEventOnReturnAddressLookupBtnSecond(e) {
		this.actionsForEventOnReturnAddressLookupBtn(e);
		this.alertBoxMessageFirst.classList.remove('hidden');
		this.alertBoxMessageSecond.classList.add('hidden');
	}

	actionsForEventOnChangeAddressCardBtn() {
		this.defaultAddressCard.classList.add('hidden');
		this.defaultAddressCard.querySelector('.js-address-card-line2').innerHTML =
			'';
		this.addressSearchBlock.classList.remove('hidden');
		this.resetSearchInputsValidation();
		this.clearSearchInputs();
		this.removeErrorMsgsForEmptyLookupInputs();
		this.setAddressInputsValues();
	}

	actionsForEventOnSaveAddressBtn(e, isEnterPressed) {
		this.setDomElements(e);
		this.onSubmitFormEvents(e, isEnterPressed);
		this.toggleDefaultDeliveryAddress(e, true, false, true);
		e.target
			.closest('form')
			.dispatchEvent(new Event('submit', { cancelable: true }));
	}

	actionsForEventOnEditDeliveryAddressBtn(e) {
		this.removeValidAddressInStorage();
		if (window.location.href.indexOf('my-account') > -1) {
			this.setValidDeliveryAddressInStorageDuringEditing(e);
		}
		this.toggleDefaultDeliveryAddress(e, false, false, true);
	}

	actionsForEventOnEditBillingAddressBtn(e) {
		this.removeValidAddressInStorage();
		this.setValidBillingAddressInStorageDuringEditing(e);
	}

	actionsForEventOnAddressSearchDropdownItem(e) {
		if (
			e.target.classList.contains('js-address-search-dropdown-item') ||
			e.target.closest('.js-address-search-dropdown-item')
		) {
			const choosenAddressElem = e.target.classList.contains(
				'js-address-search-dropdown-item',
			)
				? e.target
				: e.target.closest('.js-address-search-dropdown-item');
			this.setChoosenAddress(choosenAddressElem);
			this.removeValidAddressInStorage();
			this.formatChoosenAddress();
			this.hideSearchAddressBlock();
		}

		if (
			!e.target.classList.contains('js-address-search-init') &&
			this.addressSearchDropdown &&
			this.addressSearchDropdown.classList.contains('is-visible') &&
			!e.target.classList.contains('js-address-search-dropdown')
		) {
			this.hideSearchDropdown();
		}
	}

	listeners() {
		if (document.querySelector('.js-address-search-wrapper')) {
			document.addEventListener('pointerup', e => {
				if (
					e.target.classList.contains('js-address-search-init') &&
					!e.target.classList.contains('is-inited')
				) {
					this.initSearch(e);
				} else if (
					e.target.classList.contains('js-add-address-btn') ||
					e.target.closest('.js-add-address-btn')
				) {
					this.toggleAddNewAddressBlockElemsDisplaying();
				} else if (
					e.target.classList.contains('js-address-search-no-results-link') ||
					e.target.closest('.js-address-search-no-results-link')
				) {
					this.actionsForEventOnNoResultsLink(e);
				} else if (
					(e.target.classList.contains('js-address-edit-btn') ||
						e.target.closest('.js-address-edit-btn')) &&
					e.target.closest('.js-shipping-address-section')
				) {
					this.actionsForEventOnEditDeliveryAddressBtn(e);
				} else if (
					(e.target.classList.contains('js-address-edit-btn') ||
						e.target.closest('.js-address-edit-btn')) &&
					e.target.closest('.js-billing-address-section')
				) {
					this.actionsForEventOnEditBillingAddressBtn(e);
				} else if (e.target.classList.contains('js-save-address-btn')) {
					this.actionsForEventOnSaveAddressBtn(e, 'false');
				} else if (
					e.target.classList.contains('js-change-address-card-btn') ||
					e.target.closest('.js-change-address-card-btn')
				) {
					this.actionsForEventOnChangeAddressCardBtn();
				} else if (
					e.target.classList.contains('js-cancel-edit-address-btn') ||
					e.target.closest('.js-cancel-edit-address-btn')
				) {
					this.toggleDefaultDeliveryAddress(e, true, true, false);
				} else if (
					e.target.classList.contains('js-return-address-lookup-btn')
				) {
					this.actionsForEventOnReturnAddressLookupBtn(e);
				} else if (
					e.target.classList.contains('js-return-address-lookup-btn-second')
				) {
					this.actionsForEventOnReturnAddressLookupBtnSecond(e);
				} else if (e.target.classList.contains('js-address-search-input')) {
					this.removeErrorMsgsForEmptyLookupInputs(e);
				}
			});

			document.addEventListener('keydown', e => {
				if (e.key === 'Enter') {
					if (
						e.target.tagName.toUpperCase() === 'INPUT' &&
						!e.target.classList.contains('js-address-search-input') &&
						e.target.closest('.js-address-results-wrapper')
					) {
						this.actionsForEventOnSaveAddressBtn(e, 'true');
					} else if (
						e.target.tagName.toUpperCase() === 'INPUT' &&
						e.target.classList.contains('js-address-search-input')
					) {
						e.preventDefault();
					} else if (
						e.target.classList.contains('js-address-search-no-results-link') ||
						e.target.closest('.js-address-search-no-results-link')
					) {
						this.actionsForEventOnNoResultsLink(e);
					} else if (
						e.target.classList.contains('js-return-address-lookup-btn')
					) {
						this.actionsForEventOnReturnAddressLookupBtn(e);
					} else if (
						e.target.classList.contains('js-return-address-lookup-btn-second')
					) {
						this.actionsForEventOnReturnAddressLookupBtnSecond(e);
					} else if (
						e.target.classList.contains('js-change-address-card-btn') ||
						e.target.closest('.js-change-address-card-btn')
					) {
						this.actionsForEventOnChangeAddressCardBtn();
					} else if (e.target.classList.contains('js-save-address-btn')) {
						this.actionsForEventOnSaveAddressBtn(e, 'true');
					} else if (
						e.target.classList.contains('js-add-address-btn') ||
						e.target.closest('.js-add-address-btn')
					) {
						this.toggleAddNewAddressBlockElemsDisplaying();
					} else if (
						(e.target.classList.contains('js-address-edit-btn') ||
							e.target.closest('.js-address-edit-btn')) &&
						e.target.closest('.js-shipping-address-section')
					) {
						this.actionsForEventOnEditDeliveryAddressBtn(e);
					} else if (
						(e.target.classList.contains('js-address-edit-btn') ||
							e.target.closest('.js-address-edit-btn')) &&
						e.target.closest('.js-billing-address-section')
					) {
						this.actionsForEventOnEditBillingAddressBtn(e);
					} else if (
						e.target.classList.contains('js-cancel-edit-address-btn') ||
						e.target.closest('.js-cancel-edit-address-btn')
					) {
						this.toggleDefaultDeliveryAddress(e, true, true, false);
					}

					this.actionsForEventOnAddressSearchDropdownItem(e);
				}
			});

			document.addEventListener('click', e => {
				this.actionsForEventOnAddressSearchDropdownItem(e);

				if (
					e.target.classList.contains('js-address-search-no-results-link') ||
					e.target.closest('.js-address-search-no-results-link')
				) {
					e.preventDefault();
				}
			});

			document.addEventListener('focusin', e => {
				if (
					e.target.classList.contains('js-address-search-init') &&
					!e.target.classList.contains('is-inited')
				) {
					this.initSearch(e);
				}
			});

			if (
				window.location.href.indexOf('delivery/add') > -1 &&
				document.querySelector('input[name="validAddress"]')
			) {
				this.setValidFlagForEditingDeliveryAddressInCheckout();
			}
		}
	}

	init() {
		this.listeners();
	}
}

export default ExperianAddressValidation;
